import createOrUpdateHiddenField from './createOrUpdateHiddenField';
import formatCAIWallet from './formatCAIWallet';

const injectCAIWalletConfig = (win, form) => {
	if (win?.DDC?.getSiteProperty('OptOutCAIWalletConfig') === true) {
		return;
	}

	const walletConfigKey = 'CAIWalletConfig';

	const data = win?.localStorage?.getItem(walletConfigKey) || '{}';
	const walletData = JSON.parse(data);

	const { interactions } = walletData;
	const { hasOpenedWallet, hasUpdatedWallet } = interactions || {};

	if (!(hasOpenedWallet || hasUpdatedWallet)) {
		return;
	}

	createOrUpdateHiddenField(
		form,
		`_custom=CAI_WALLET_CONFIG=-1=${walletConfigKey}`,
		formatCAIWallet(walletData)
	);
};

export default injectCAIWalletConfig;
